// extracted by mini-css-extract-plugin
var _1 = "Tag_border__e6336";
var _2 = "Tag_color__6fdf6";
var _3 = "Tag_icon__480a7";
var _4 = "Tag_root__02daa";
export { _1 as "border", _2 as "color", _3 as "icon", _4 as "root" }
